import { render, staticRenderFns } from "./RoundSetNumbers.vue?vue&type=template&id=251e0ca6&scoped=true&"
import script from "./RoundSetNumbers.vue?vue&type=script&lang=js&"
export * from "./RoundSetNumbers.vue?vue&type=script&lang=js&"
import style0 from "./RoundSetNumbers.vue?vue&type=style&index=0&id=251e0ca6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251e0ca6",
  null
  
)

export default component.exports